import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e22dba5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid h-100" }
const _hoisted_2 = { class: "row h-100" }
const _hoisted_3 = { class: "col h-100 text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "title-1" }, "Bienvenue sur", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "title-2" }, "OverRun", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "title-3" }, " Le site d'inscription aux courses des 24 heures de l'INSA ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0 m-2" }, "Commencer mon inscription", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:overrun@24heures.org" }, " overrun@24heures.org", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0 m-2" }, "Se connecter", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _withDirectives(_createElementVNode("button", {
          class: "btn btn-primary",
          id: "begin-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
        }, _hoisted_8, 512), [
          [_vShow, _ctx.isRegistrationOpen]
        ]),
        _withDirectives(_createElementVNode("p", null, [
          _createTextVNode(" Les inscriptions sont actuellement fermées. "),
          _hoisted_9,
          _createTextVNode(" Elles sont ouvertes du "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.registrationStartDate), 1),
          _createTextVNode(" au "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.registrationEndDate), 1),
          _createTextVNode(". "),
          _hoisted_10,
          _createTextVNode(" Si vous pensez que c'est une erreur, contactez-nous à l'adresse suivante : "),
          _hoisted_11
        ], 512), [
          [_vShow, !_ctx.isRegistrationOpen]
        ]),
        _hoisted_12,
        _createElementVNode("button", {
          class: "btn btn-primary",
          id: "login-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
        }, _hoisted_14)
      ])
    ])
  ]))
}